<template>
  <div class="container">
    <div class="footer">
      <div class="content w">
        <div class="logo">
          <img src="../assets/float-logo.png" alt="" />
        </div>
        <div class="info">
          <p>关于我们</p>
          <span>南京知车君网络科技有限公司</span>
          <span>地址：南京市栖霞区燕子矶街道和燕路371号东南大学国家大学科技园科创楼B503室</span>
          <span>网址：www.tosunk.cn</span>
        </div>
        <div class="info" style="width:20%;">
          <p>联系我们</p>
          <span>王 祥 :13914490574</span>
        </div>
        <div class="erweima">
          <img src="../assets/二维码.jpg" alt="" />
          <span>扫一扫关注</span>
        </div>
      </div>
      <div class="icp">
        <a style="color: #FFFFFF" target="_blank" href="https://beian.miit.gov.cn">苏ICP备15061658号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.footer {
  background: url(../assets/float.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.content {
  color: #ccc;
  display: flex;
  justify-content: center;
  padding: 30px 0 15px;
  .logo {
    width: 20%;
    display: flex;
    justify-content: center;
    img {
      width: 60%;
      object-fit: contain;
    }
  }
  .info {
    width: 40%;
    p {
      color: #fff;
      line-height: 3;
      font-size: 18px;
    }
    span {
      color: #999;
      line-height: 2;
      display: block;
    }
  }
  .erweima {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 55%;
      object-fit: contain;
    }
    span {
      color: #fff;
      font-size: 14px;
      margin-top: 4px;
    }
  }
}
.icp {
  line-height: 40px;
  text-align: center;
  border-top: 1px solid #ccc;
}
</style>
